angular.module("invioLinkAdv.components", [])
    .component("invioLinkAdv", {
        templateUrl: "ng/components/invioLinkAdv/invioLinkAdv.view.html",
        bindings: {},
        controller: InvioLinkAdvController,
        controllerAs: "invioLinkAdvCtrl"
    })

function InvioLinkAdvController(
    $scope,
    $uniService,
    $rootScope
) {

    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            contratto: "",
            modulo: "",
            ndgSogg: "",
            emailDest: "",
            emailOpAlba: "",
            note: ""
        }

    }

    self.enableButton = function () {
        return $scope.sendLinkAdv &&
            $scope.sendLinkAdv.$invalid;
    }


    self.despatch = function () {
        self.loading = true;

        $uniService.sendLink(self.supportModel)
            .then(function (response) {
                if (response.success) {
                    $rootScope.$broadcast("addAlert", {
                        text: "QUEST_ADV_SEND"
                    })
                    self.supportModel = {}
                }
                self.loading = false;
            })
            .catch(function (error) {
                console.log(error);
                self.loading = false;
            })
    }

}